import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setPrDispoInstructionsOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getPrDispoInstructionsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPrDispoInstructionsOptions])
    const { entity } = response
    entity.push({ id: null, name: 'Other' } as any)
    yield put(setPrDispoInstructionsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPrDispoInstructionsOptions() error: ${e}`))
  }
}
export function* getPrDispoInstructionsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPrDispoInstructionsOptions)
}
